import { useMutation } from '@tanstack/react-query'

import { AxiosError } from 'axios'
import { ErrorHandling } from '../../../@types/ErrorHandling'
import {
  SimulationSummaryDownloadClientRequest,
  SimulationSummaryDownloadClientResponse,
} from '../../../@types/SimulationSummaryDownload'
import { api } from '../../../Services/API'
import { useSimulationSummaryDownloadStore } from '../../../Stores/useSimulationSummaryDownloadStore'
import { API_ROUTES } from '../../../constants/apiRoutes'
import { useErrorRequest } from '../../useErrorRequest'

const request = async (payload: SimulationSummaryDownloadClientRequest) => {
  const response = await api.post<SimulationSummaryDownloadClientResponse>(
    API_ROUTES.simulationSummaryDownload,
    payload,
  )

  return response.data
}

export const useSimulationSummaryDownload = () => {
  const { setSimulationSummaryDownload } = useSimulationSummaryDownloadStore()
  const { handleErrorRequest } = useErrorRequest()

  return useMutation({
    mutationFn: (payload: SimulationSummaryDownloadClientRequest) =>
      request(payload!),
    onSuccess(data) {
      setSimulationSummaryDownload(data)
    },
    onError(error: AxiosError<ErrorHandling[]>) {
      handleErrorRequest({ error })
    },
  })
}
